import phoneIcon from "../../../resources/images/interview-rounds/images/phone-icon-phone.svg";
import AmpleHireImageTag from "../../ample-hire-html-tags/ample-hire-image-tag";
import Tooltip from "../../miscellaneous/tooltip";
import { useGlobalContext } from "../../../context";

const AdminHeader2 = () => {
  const { rootColor } = useGlobalContext();
  return (
    <header className="int-header">
      <aside className="col xl8 l8 m6 s12">
        <div className="logo-brand">
          <AmpleHireImageTag imgSrc={rootColor.logoUrl} altText="BrandLogo" />
        </div>
      </aside>
      <aside className="col xl4 l4 m6 s12">
        <ul className="suppor-ul">
          <li style={{ fontWeight: "600", color: "var(--text-secondary)" }}>Need Help?</li>
          <li>
            <AmpleHireImageTag imgSrc={phoneIcon} altText="Call Support" />
          </li>
          <li style={{ fontWeight: "600", color: "var(--primary-color)" }}>9341 555 666</li>
          <i className="show-details infermation-ico-black" style={{ padding: "0" }}>
            i
            <Tooltip divTagCssClasses={"infbox-click-header information-box-header"}>
              <p>
                Facing technical issues? Reach our support team at 9341 555
                666 (available 8 AM - 9 PM)
              </p>
            </Tooltip>
          </i>
        </ul>
      </aside>
    </header>
  );
};

export default AdminHeader2;
